import React, { useState, useEffect } from "react";
import "../css/BImage.css";
import Spinner from "./Spinner.mjs";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as FASolid from '@fortawesome/free-solid-svg-icons';

const BImage = ({ src, alt, downloadName }) => {
    const [loading, setLoading] = useState(true);
    const [showFullscreen, setShowFullscreen] = useState(false);

    // Toggle fullscreen state
    const toggleFullscreen = (e) => {
        if (e) e.stopPropagation();
        setShowFullscreen(!showFullscreen);
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        const link = document.createElement("a");
        link.href = src;
        link.download = downloadName || "download";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Handle ESC key to close fullscreen
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === "Escape") {
                setShowFullscreen(false);
            }
        };
        if (showFullscreen) {
            window.addEventListener("keydown", handleEsc);
        }
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, [showFullscreen]);

    return (
        <>
            {/* 1. The Thumbnail (Always Visible) */}
            <div className="bimage-container" onClick={toggleFullscreen}>
                {loading && <Spinner />}

                <img
                    src={src}
                    alt={alt}
                    onLoad={() => setLoading(false)}
                    className={`bimage ${loading ? "hidden" : ""}`}
                />

                {!loading && (
                    <div className="bimage-hover-icons">
                        <FontAwesomeIcon
                            icon={FASolid.faExpand}
                            className="icon"
                            onClick={toggleFullscreen}
                            title="Fullscreen"
                        />
                        <FontAwesomeIcon
                            icon={FASolid.faDownload}
                            className="icon"
                            onClick={handleDownload}
                            title="Download"
                        />
                    </div>
                )}
            </div>

            {/* 2. The Fullscreen Overlay (Rendered via Portal) */}
            {showFullscreen && createPortal(
                <div
                    className="fullscreen-overlay"
                    onClick={toggleFullscreen}
                    role="dialog"
                    aria-modal="true"
                    aria-label={alt ? `${alt} — fullscreen preview` : 'Fullscreen image preview'}
                >
                    <button
                        type="button"
                        className="fullscreen-close"
                        onClick={toggleFullscreen}
                        aria-label="Close fullscreen preview"
                        title="Close (Esc)"
                    >
                        &times;
                    </button>
                    <img
                        src={src}
                        alt={alt}
                        className="fullscreen-image"
                        onClick={(e) => e.stopPropagation()} // Clicking image shouldn't close it
                    />
                </div>,
                document.body
            )}
        </>
    );
};

export default BImage;